import { strictParseDate } from "./Format";

export function validateIsoDate(value: string): boolean | string {
   try {
      return value === "" || strictParseDate(value) instanceof Date;
   }
   catch (e) {
      return "Enter a valid date.";
   }
}

export function validateInteger(value: string): boolean | string {
   return value === "" || /^\d+$/.test(value) || "Enter a valid integer";
}
